/**
 * Go-live de los premios reales (cuando se puede COBRAR).
 *
 * Mismo criterio que el dashboard de milestones del ranking: hasta esta fecha se muestra
 * sólo el teaser (ver `ranking-page.tsx` → `PRIZES_LIVE_FROM`). Atado a esa fecha:
 *   - El campo "Alias de Mercado Pago" se muestra como "Próximamente" y BLOQUEADO hasta el
 *     go-live; después queda editable y funcional.
 *   - Una vez vivo, el alias pasa a ser REQUERIDO para cobrar → su ausencia deja el perfil
 *     incompleto y dispara el warning (⚠️) del header y de Settings.
 *
 * ⚠️ Mantener en sync con `PRIZES_LIVE_FROM` de `ranking-page.tsx` (hoy duplicado; unificar
 *    cuando ambas ramas convivan). Al arrancar los premios de verdad, poné acá la fecha real.
 */
export const PRIZES_LIVE_FROM = new Date(2027, 0, 1);

/** true una vez que los premios están vivos (se puede cobrar). Se evalúa en cada llamada. */
export const prizesAreLive = (): boolean => new Date() >= PRIZES_LIVE_FROM;
